const GameRuleComponent = () => import('@/views/card/GameRule/GameRuleView')

export default [
    {
        path:'/GameRuleIndex',
        name:'GameRuleRouter',
        component:GameRuleComponent
    }
]